import { createElement, lazy } from "react"
import type { ComponentType, LazyExoticComponent, ReactElement } from "react"

import { ERoute } from "@/3514/constants"

import { type TParticipantOnboardingPageProps as TPageProps } from "./participant.onboarding.ui.types"

const ParticipantOnboardingProfilePage: LazyExoticComponent<ComponentType<TPageProps>> = lazy(
        (): Promise<{ default: ComponentType<TPageProps> }> => import("./participant.onboarding.page.profile")
    ),
    ParticipantOnboardingVideoPage: LazyExoticComponent<ComponentType<TPageProps>> = lazy(
        (): Promise<{ default: ComponentType<TPageProps> }> => import("./participant.onboarding.page.video")
    ),
    ParticipantOnboardingModulesPageLegacy: LazyExoticComponent<ComponentType<TPageProps>> = lazy(
        (): Promise<{ default: ComponentType<TPageProps> }> => import("./participant.onboarding.page.legacy.modules")
    ),
    ParticipantOnboardingDiagnosticResponsePageLegacy: LazyExoticComponent<ComponentType<TPageProps>> = lazy(
        (): Promise<{ default: ComponentType<TPageProps> }> =>
            import("./participant.onboarding.page.legacy.diagnostic-response")
    ),
    ParticipantOnboardingDiagnosticPage: LazyExoticComponent<ComponentType<TPageProps>> = lazy(
        (): Promise<{ default: ComponentType<TPageProps> }> => import("./participant.onboarding.page.diagnostic")
    ),
    ParticipantOnboardingReflectionPage: LazyExoticComponent<ComponentType<TPageProps>> = lazy(
        (): Promise<{ default: ComponentType<TPageProps> }> => import("./participant.onboarding.page.reflection")
    ),
    ParticipantOnboardingHoldsPage: LazyExoticComponent<ComponentType<TPageProps>> = lazy(
        (): Promise<{ default: ComponentType<TPageProps> }> => import("./participant.onboarding.page.holds")
    ),
    ParticipantOnboardingCoachPage: LazyExoticComponent<ComponentType<TPageProps>> = lazy(
        (): Promise<{ default: ComponentType<TPageProps> }> => import("./participant.onboarding.page.coach")
    ),
    ParticipantOnboardingRedirectPage: LazyExoticComponent<ComponentType<TPageProps>> = lazy(
        (): Promise<{ default: ComponentType<TPageProps> }> => import("./participant.onboarding.page.redirect")
    )

const participantOnboardingPages: { component(props: TPageProps): ReactElement; path: string }[] = [
    {
        component: (props: TPageProps): ReactElement => createElement(ParticipantOnboardingProfilePage, props),
        path: ERoute.Participant_OnboardingProfile
    },
    {
        component: (props: TPageProps): ReactElement => createElement(ParticipantOnboardingVideoPage, props),
        path: ERoute.Participant_OnboardingVideo
    },
    {
        component: (props: TPageProps): ReactElement => createElement(ParticipantOnboardingModulesPageLegacy, props),
        path: ERoute.Participant_OnboardingModules_Legacy
    },
    {
        component: (props: TPageProps): ReactElement => createElement(ParticipantOnboardingDiagnosticPage, props),
        path: ERoute.Participant_OnboardingDiagnostic
    },
    {
        component: (props: TPageProps): ReactElement =>
            createElement(ParticipantOnboardingDiagnosticResponsePageLegacy, props),
        path: ERoute.Participant_OnboardingDiagnosticResults_Legacy
    },
    {
        component: (props: TPageProps): ReactElement => createElement(ParticipantOnboardingReflectionPage, props),
        path: ERoute.Participant_OnboardingReflection
    },
    {
        component: (props: TPageProps): ReactElement => createElement(ParticipantOnboardingHoldsPage, props),
        path: ERoute.Participant_OnboardingHolds
    },
    {
        component: (props: TPageProps): ReactElement => createElement(ParticipantOnboardingCoachPage, props),
        path: ERoute.Participant_OnboardingCoach
    },
    {
        component: (_props: TPageProps): ReactElement => createElement(ParticipantOnboardingRedirectPage),
        path: ERoute.Participant_OnboardingRedirect
    }
]

export { participantOnboardingPages }
